import script from "./psiStockCashInOutBill.vue?vue&type=script&setup=true&lang=js"
export * from "./psiStockCashInOutBill.vue?vue&type=script&setup=true&lang=js"

import "./psiStockCashInOutBill.vue?vue&type=style&index=0&id=5fb37718&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fb37718"]])

export default __exports__